export default __webpack_public_path__ + "static/og-image-0336d02929abdacf44907adf2c8db850.jpg";